import React from 'react';
import { Navigate } from 'react-router-dom';
import useAdmin from '../hooks/useAdmin';
import useAuth from '../hooks/useAuth';

const PrivateRoute = ({children}) => {
    const isLoggedIn = useAuth();
    const isAdmin = useAdmin();

    if(isLoggedIn && isAdmin){
        return <Navigate to='/admin/dashboard' />
    }
    
   return isLoggedIn ? children : <Navigate to='/' />
};

export default PrivateRoute;


